import script from "./userbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./userbar.vue?vue&type=script&lang=ts&setup=true"

import "./userbar.vue?vue&type=style&index=0&id=b3d3e682&lang=scss&scoped=true"

import exportComponent from "E:\\vue\\saudiInspectionSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d3e682"]])

export default __exports__